export default "__VITE_ASSET__B0ERa$9O__"